import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { DeleteProjectResponseBody } from "@imagine/ai-service/shared-types/route-types";
import { toast } from "sonner";
import { aiServiceFetch } from "@/lib/ai-service-client";
import { HttpError } from "@/lib/http-error";

export function useDeleteProject({
  onSuccess,
  onError,
}: { onSuccess?: () => void; onError?: (error: Error) => void } = {}) {
  const queryClient = useQueryClient();
  return useMutation<DeleteProjectResponseBody, Error, { projectId: string }>({
    mutationFn: async ({ projectId }) => {
      const response = await aiServiceFetch(`/api/projects/${projectId}`, {
        method: "DELETE",
      });

      if (!response.ok) {
        throw await HttpError.fromResponse(response);
      }

      return response.json();
    },
    onError: (error) => {
      onError?.(error);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["my-projects"] });
      toast.success("Project deleted successfully");
      onSuccess?.();
    },
  });
}
